import { render } from "./InputVat.vue?vue&type=template&id=0647aef5"
import script from "./InputVat.vue?vue&type=script&lang=js"
export * from "./InputVat.vue?vue&type=script&lang=js"
script.render = render

export default script